import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { activeTabIdAtom, panelStateAtom } from '../atoms/session-atoms';
import { VERSION_FINGERPRINT } from '../bi/constants';
import { BiScreenTypes } from '../bi/types';
import { ACCESSIBILITY_WIZARD_TAB_IDS } from '../consts';
import { useA11yWizardAdapter } from './use-a11y-wizard-adapter';
import { useSessionInfoContext } from './use-session-info-context';
export const useBiCommon = () => {
  const {
    editorHost
  } = useA11yWizardAdapter();
  const {
    lastScanTimeStamp
  } = useAtomValue(panelStateAtom);
  const relevantTimestamp = lastScanTimeStamp;
  const activeTabId = useAtomValue(activeTabIdAtom);
  // Depend on the primitive fields rather than the whole sessionInfo object:
  // the SessionInfoContext provider passes a new value object every render, so
  // depending on the object identity would recompute commonParams (and every
  // downstream BI logger / effect) on every render.
  const {
    esi,
    locale,
    msid,
    referral,
    wizard_session_start_ts
  } = useSessionInfoContext();
  const commonParams = useMemo(() => ({
    editor_type: editorHost,
    esi,
    locale,
    msid,
    referral,
    site_scan_timestamp: relevantTimestamp,
    version_display: VERSION_FINGERPRINT,
    wizard_session_start_ts
  }), [editorHost, relevantTimestamp, esi, locale, msid, referral, wizard_session_start_ts]);
  const screenType = useMemo(() => {
    return relevantTimestamp === undefined ? BiScreenTypes.WelcomeScreen : activeTabId === ACCESSIBILITY_WIZARD_TAB_IDS.DETECTED_TASKS ? BiScreenTypes.DetectedIssues : BiScreenTypes.ManualTasks;
  }, [activeTabId, relevantTimestamp]);
  return {
    commonParams,
    screenType
  };
};
//# sourceMappingURL=use-bi-common.js.map